import { useCallback, useState } from 'react';

export const useFlag = (initialValue = false) => {
	const [flag, setFlag] = useState(initialValue);

	const onTurnOn = useCallback(() => setFlag(true), []);

	const onTurnOff = useCallback(() => setFlag(false), []);

	const onToggle = useCallback(() => setFlag((prev) => !prev), []);

	return {
		flag,
		onTurnOn,
		onTurnOff,
		onToggle,
	};
};
